import { connect } from 'react-redux';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import {
  applyWhatIf,
  fetchWhatIfOptions,
  initialPlanImpact,
  planImpact,
  updateWhatIfsData,
} from '../../WhatIfsActions';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import {
  areOptionsLoaded,
  impactSelector,
  isOPLMonteCarloSelector,
  loading,
  nullableFpIdSelector,
  nullableGroupTitleSelector,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
} from '../../WhatIfsSelector';
import { RothConversionWhatIf } from './RothConversion';
import { selectRothConversionOptions, selectRothConversions } from './RothConversionSelector';
import { showTaxBracketOptionSelector } from '../../../FinancialPlan/FinancialPlanSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state),
  goalId: selectedGoalId(state),
  areOptionsLoaded: areOptionsLoaded(state),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  loading: loading(state),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
  planImpactItems: impactSelector(state, ownProps),
  options: selectRothConversionOptions(state),
  conversions: selectRothConversions(state, ownProps),
  isOPLMonteCarlo: isOPLMonteCarloSelector(state),
  showTaxBracketOption: showTaxBracketOptionSelector(state),
});

const mapDispatchToProps = dispatch => ({
  storeData: (clientId, goalId, whatIfType, data) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },
  fetchPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      planImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchInitialPlanImpact: (clientId, fpId, goalId, whatIf, whatIfTemplate) => {
    dispatch(
      initialPlanImpact(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
  fetchData: (clientId, fpId, goalId, whatIfType) => {
    dispatch(fetchWhatIfOptions(clientId, fpId, goalId, RouteDictionary[whatIfType], whatIfType));
  },
  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RothConversionWhatIf);
